import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React, {useEffect, useRef} from "react"

import FeaturesNavigationButton from "./FeaturesNavigationButton/FeaturesNavigationButton"
import FeaturesNavigationLink from "./FeaturesNavigationLink/FeaturesNavigationLink"
import styles from "./StudioFeaturesNavigationBar.module.scss"

type Props = {
	data: AdvancedSideAssetMainContent[]
	active: number
	simple?: boolean
	asButton?: boolean
	onClick?: (id: number) => void
}

const StudioFeaturesNavigationBar = (props: Props) => {
	const containerRef = useRef<HTMLDivElement | null>(null)

	const activeItemId = props.active
	useEffect(() => {
		if (containerRef.current && activeItemId) {
			const container = containerRef.current
			const activeItem = document.getElementById(String(activeItemId))

			if (activeItem) {
				// Use type assertion to assert that the activeItem is an HTMLDivElement
				const activeItemWidth = (activeItem as HTMLDivElement)
					.offsetWidth

				// Calculate the scrollLeft position to center the active item
				const containerWidth = container.offsetWidth
				const activeItemLeft = activeItem.offsetLeft
				const scrollLeft =
					activeItemLeft - (containerWidth - activeItemWidth) / 2

				// Apply the scrollLeft value to center the active item
				container.scrollLeft = scrollLeft
			}
		}
	}, [activeItemId])

	return (
		<div
			ref={containerRef}
			className={`${styles.titleContainer} ${
				props.asButton ? styles.button : styles.link
			}`}
		>
			{props.data.map(
				(element: AdvancedSideAssetMainContent, index: number) => {
					return (
						<React.Fragment key={index}>
							{!props.asButton && (
								<FeaturesNavigationLink
									active={props.active === index}
									data={element}
									id={index}
								/>
							)}
							{props.asButton && (
								<FeaturesNavigationButton
									active={props.active === index}
									data={element}
									id={index}
									simple={props.simple}
									onClick={props?.onClick}
								/>
							)}
						</React.Fragment>
					)
				},
			)}
		</div>
	)
}

export default StudioFeaturesNavigationBar
